import { Checkbox, CheckboxProps } from '@cint/wonderment';
import { useController, useFormContext } from 'react-hook-form';

interface CheckboxFieldProps extends Omit<CheckboxProps, 'label'> {
  name: string;
  label?: string;
}

export const CheckboxField = ({
  name,
  label,
  ...props
}: CheckboxFieldProps) => {
  const { control } = useFormContext();

  const {
    field: { value, onChange },
  } = useController({
    control,
    name,
  });

  return (
    <div>
      <Checkbox
        {...props}
        id={name}
        labelProps={{
          label,
        }}
        onCheckedChange={onChange}
        status={value ? 'checked' : 'unchecked'}
      />
    </div>
  );
};
